// src/pages/salary/components/InstancesTable.jsx
import { getInstanceTypeLabel } from "../config/translations_Salary";

const InstancesTable = ({ rows, theme, isRTL, t, emptyText, amountColor, amountSign }) => {
  const isDark = theme === "dark";
  const headerBg = isDark ? "rgba(46, 124, 186, 0.18)" : "rgba(46, 124, 186, 0.1)";
  const borderColor = isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)";
  const textColor = isDark ? "#ffffff" : "#0f172a";
  const mutedColor = isDark ? "rgba(255,255,255,0.7)" : "rgba(26,26,26,0.65)";

  const total = (rows || []).reduce((sum, r) => sum + (Number(r.amount) || 0), 0);

  const cellStyle = {
    padding: "12px 14px",
    borderBottom: `1px solid ${borderColor}`,
    color: textColor,
    fontSize: "clamp(12px, 1.6vw, 14px)",
    textAlign: isRTL ? "right" : "left",
  };
  const headerCellStyle = {
    ...cellStyle,
    fontWeight: "700",
    color: textColor,
    background: headerBg,
    borderBottom: `2px solid ${borderColor}`,
  };

  return (
    <div style={{ width: "100%", overflowX: "auto", direction: isRTL ? "rtl" : "ltr" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          minWidth: "480px",
          background: isDark ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.6)",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <thead>
          <tr>
            <th style={headerCellStyle}>{t.type}</th>
            <th style={headerCellStyle}>{t.description}</th>
            <th style={{ ...headerCellStyle, textAlign: isRTL ? "left" : "right" }}>
              {t.amount} ({t.egp})
            </th>
          </tr>
        </thead>
        <tbody>
          {rows && rows.length > 0 ? (
            rows.map((row, idx) => {
              const meta = [];
              if (row.days != null && row.days !== "") meta.push(`${row.days} ${t.days}`);
              if (row.hours != null && row.hours !== "") meta.push(`${row.hours} ${t.hours}`);
              const description = [row.description, meta.join(" · ")].filter(Boolean).join(" — ");
              return (
                <tr key={row.id || idx}>
                  <td style={cellStyle}>{getInstanceTypeLabel(row.type, t)}</td>
                  <td style={{ ...cellStyle, color: mutedColor }}>{description || "-"}</td>
                  <td
                    style={{
                      ...cellStyle,
                      textAlign: isRTL ? "left" : "right",
                      color: amountColor,
                      fontWeight: "600",
                    }}
                  >
                    {amountSign}
                    {(Number(row.amount) || 0).toFixed(2)} {t.egp}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td style={{ ...cellStyle, textAlign: "center", color: mutedColor }} colSpan={3}>
                {emptyText}
              </td>
            </tr>
          )}
        </tbody>
        {rows && rows.length > 0 && (
          <tfoot>
            <tr>
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "700",
                  background: headerBg,
                  borderBottom: "none",
                }}
                colSpan={2}
              >
                {t.total}
              </td>
              <td
                style={{
                  ...cellStyle,
                  textAlign: isRTL ? "left" : "right",
                  fontWeight: "700",
                  color: amountColor,
                  background: headerBg,
                  borderBottom: "none",
                }}
              >
                {amountSign}
                {total.toFixed(2)} {t.egp}
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
};

export default InstancesTable;